import { Suspense } from 'react';

import { Loader } from 'shared/ui/Loader';

import ExternalMatches from './ExternalMatches';

export const ExternalMatchesAsync = () => {
  return (
    <Suspense fallback={<Loader />}>
      <ExternalMatches />
    </Suspense>
  );
};
